import { migraVuelo as baseTitles } from "consts/titulos-de-tablas";

export const VUELO_ESTADO_LABELS = { A: "Abierto", C: "Cerrado" };
export const VUELO_TIPO_LABELS = { E: "Entrada", S: "Salida" };

export const migraVueloColumns = baseTitles.map((t) => {
    if (t.field === "migraVueloEstado") {
        return {
            ...t,
            valueGetter: ({ value }) => VUELO_ESTADO_LABELS[value] ?? value ?? "",
        };
    }
    if (t.field === "migraVueloTipo") {
        return {
            ...t,
            valueGetter: ({ value }) => VUELO_TIPO_LABELS[value] ?? value ?? "",
        };
    }
    return t;
});

export function mapMigraVueloRow(item) {
    const {
        migraVueloId,
        migraVueloPasoId,
        migraPasoNombre,
        migraVueloTipo,
        migraVueloFecha,
        migraVueloIdentificacion,
        migraVueloOrigenDestino,
        migraVueloEstado,
        migraVueloVersion,
        pasajerosPorEstado,
    } = item;

    const totalPasajeros = Object.values(pasajerosPorEstado || {}).reduce((acc, n) => acc + n, 0);

    return {
        id: migraVueloId,
        migraVueloId,
        migraVueloPasoId,
        migraPasoNombre,
        migraVueloTipo,
        migraVueloFecha,
        migraVueloIdentificacion,
        migraVueloOrigenDestino,
        migraVueloEstado,
        migraVueloVersion,
        pasajerosPorEstado,
        totalPasajeros,
    };
}
